import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
import RequestPreview_vue_vue_type_script_setup_true_lang_default from "./RequestPreview.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                   */
//#region src/components/RequestPreview.vue
var RequestPreview_default = /*#__PURE__*/ _plugin_vue_export_helper_default(RequestPreview_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-e049f4c9"]]);
//#endregion
export { RequestPreview_default as default };

//# sourceMappingURL=RequestPreview.vue.js.map